import React from 'react';
import { useDispatch } from 'react-redux';
import Btn, { btnTypes } from '../../../../../../components/btn';
import {
  actionCreators,
  sliceKeys,
  acceptanceCreationSteps,
} from '../../../../model';

const { stepChanged } = actionCreators[sliceKeys.createPage];

const ToAddressesSetup = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(stepChanged(acceptanceCreationSteps.addressesSetup));
  };

  return (
    <Btn type={btnTypes.primaryInvert} onClick={handleClick}>
      Изменить
    </Btn>
  );
};

export default ToAddressesSetup;
